import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";

import DataTable from "components/DataTable";
import Header from "components/Header";
import { routes } from "constants/routes";
import { PAYMENT_CONNECTED_BOARDING_HEADER } from "constants/user-settings";
import { convertPaymentSpeedOption } from "helpers/convertFormData";
import useDeviceType from "hooks/useDeviceType";
import MainLayout from "layouts/Main";
import { IOption } from "models/Form";
import { IInvitedGroup } from "models/User";
import { RootState } from "store";
import InvitedGroupItem from "../../modules/Carrier/InvitedGroupItem";
import styles from "./style.module.scss";

export default function PaymentPreferences() {
  const { isDesktop } = useDeviceType();
  const { invitedGroups }: { invitedGroups: IInvitedGroup[] } = useSelector(
    (state: RootState) => state.userState
  );

  const { control, reset } = useForm<{
    paymentSpeed: IOption[];
  }>();

  const fetchConnectedInvites = async () => {
    reset({
      paymentSpeed: invitedGroups.map((group) => {
        const defaultSpeed = group.payment_speed_options.find((speed) => speed.is_default);
        return convertPaymentSpeedOption(defaultSpeed!);
      })
    });
  };

  useEffect(() => {
    if (invitedGroups) {
      fetchConnectedInvites();
    }
  }, [invitedGroups]);

  return invitedGroups ? (
    <MainLayout
      desktopTitle="Connections"
      customHeader={<Header label="Connections" goBackPath={routes.SETTINGS} isHideDesktop />}
      className={styles.paymentContainer}>
      <h3 className="mb-5 text-base mobile:text-sm mobile:mb-3">
        Contact the broker listed to update your payment preference
      </h3>

      {isDesktop ? (
        <form>
          <DataTable
            headers={PAYMENT_CONNECTED_BOARDING_HEADER(control)}
            data={invitedGroups.map((data) => ({
              ...data,
              paymentSpeed: data.payment_speed_options
            }))}
            sortDisableList={["group_data.tms_url"]}
          />
        </form>
      ) : (
        <div className={styles.wrapper}>
          {invitedGroups.length ? (
            invitedGroups.map((item) => (
              <InvitedGroupItem key={item.id} type="connected" data={item} />
            ))
          ) : (
            <span className={styles.noData}>No Data Available</span>
          )}
        </div>
      )}
    </MainLayout>
  ) : null;
}
